import { CommonModule, NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';
import { PdpEcolodgeHostSkeletonComponent } from "../../ecolodge/skeletons/pdp-ecolodge-host-skeleton/pdp-ecolodge-host-skeleton.component";

@Component({
  selector: 'iho-pdp-skeleton',
  standalone: true,
  imports: [
    NgFor,
    SkeletonComponent,
    CommonModule,
    PdpEcolodgeHostSkeletonComponent
  ],
  templateUrl: './pdp-skeleton.component.html',
  styleUrls: ['./pdp-skeleton.component.scss'],
})
export class PdpSkeletonComponent {
  @Input() isMobile = false;
  constructor() {

  }
}
